import { render, staticRenderFns } from "./RiskGrpUpperText.vue?vue&type=template&id=da0ecbd6&"
import script from "./RiskGrpUpperText.vue?vue&type=script&lang=js&"
export * from "./RiskGrpUpperText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports